import { getPeaks } from '@/service/audioList';
import { useAudioPlayerStore } from '@/state/audio-player-store';
import { StylefilterDetailDto } from '@/service/type';
import { cn } from '@/utils';
import { useRequest } from 'ahooks';
import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';

interface WaveFormProps {
  songId: string;
  duration: number;
  styleFilterObj?: StylefilterDetailDto;
}

export const WaveForm: React.FC<WaveFormProps> = ({ songId, duration, styleFilterObj }) => {
  const { data } = useRequest(() => getPeaks({ songId }));
  const peaks = data?.data?.peaks;
  const containerRef = useRef(null);
  const { playAudioInfo } = useAudioPlayerStore();
  const isCurrentSong = playAudioInfo?.id === songId;
  const { currentTime } = useAudioPlayerStore();
  const [waveSurfer, setWaveSurfer] = useState<WaveSurfer | null>(null);

  let styleFilterCode = styleFilterObj?.code;
  if (styleFilterCode && styleFilterCode.endsWith('-HIGH')) {
    styleFilterCode = styleFilterCode.substring(0, styleFilterCode.lastIndexOf('-'));
  }

  useEffect(() => {
    if (containerRef.current && peaks?.length) {
      const waveSurfer = WaveSurfer.create({
        container: containerRef.current,
        barRadius: 1,
        height: 20,
        fillParent: true,
        hideScrollbar: true,
        progressColor: '#F2D1C8',
        barHeight: 0.9,
        waveColor: '#ff5b27',
        cursorColor: 'transparent',
        normalize: false,
        sampleRate: 48000,
        peaks,
        duration, //use pre-decoded must have
      });
      setWaveSurfer(waveSurfer);
    }
  }, [containerRef, peaks]);

  useEffect(() => {
    if (waveSurfer) {
      if (isCurrentSong) {
        waveSurfer?.setTime(currentTime);
      } else {
        waveSurfer?.setTime(0);
      }
    }
  }, [currentTime, waveSurfer, isCurrentSong]);
  useEffect(() => {
    if (waveSurfer) {
      if (isCurrentSong) {
        waveSurfer?.setOptions({ waveColor: '#ff5b27' });
      } else {
        waveSurfer?.setOptions({ waveColor: '#0000001a' });
      }
    }
  }, [waveSurfer, isCurrentSong]);

  return (
    <div className="w-full relative">
      <div className=" overflow-hidden w-full relative z-0">
        <div ref={containerRef} className={cn('lg:block relative h-[20px] mt-[8px] flex-1 ml-[-8px] mr-[-16px]')}>
          <div
            className={cn('absolute   transition-all z-30 w-full h-full ', {
              // "dotted-waveform ": loading
            })}
          ></div>
          {/* {loading && <LoadingBar className=" w-full h-14 " />} */}
        </div>
      </div>
      {styleFilterObj && (
        <div
          className=" flex items-center gap-[10px] mt-[4px] z-10 absolute right-0 top-0 w-[18px] h-[29px]  rounded-[4px] bg-jen-orange"
          style={{
            background: styleFilterObj?.thumb_album_cover ? `url(${styleFilterObj?.thumb_album_cover})` : '',

            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            boxShadow:
              '18px 29px 9px 0px rgba(0, 0, 0, 0.00), 11px 18px 9px 0px rgba(0, 0, 0, 0.03), 6px 10px 7px 0px rgba(0, 0, 0, 0.09), 3px 5px 5px 0px rgba(0, 0, 0, 0.16), 1px 1px 3px 0px rgba(0, 0, 0, 0.19)',
          }}
        >
          <div className="w-full h-full border border-[rgba(255,255,255,0.3)] absolute left-0 top-0  rounded-[4px]" />
        </div>
      )}
    </div>
  );
};
